import type { useKagami } from "../state/useKagami";
import { mutedColor } from "./primitives";

type K = ReturnType<typeof useKagami>;

export function Leaderboards({ k }: { k: K }) {
  return (
    <div>
      <h3 style={{ margin: "0 0 16px" }}>Leaderboards</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24 }}>
        {k.boards.map((b) => (
          <section key={b.name}>
            <h6 style={{ margin: "0 0 8px", color: "var(--color-accent)" }}>{b.name}</h6>
            <div>
              {b.rows.map((r) => (
                <div key={r.id} className="k-row" onClick={() => k.setSelId(r.id)} style={{
                  display: "flex", alignItems: "center", gap: 10, padding: "7px 8px", borderRadius: 6,
                  cursor: "pointer", borderBottom: `1px solid ${mutedColor(8)}`,
                }}>
                  <span style={{ fontFamily: "var(--font-heading)", fontSize: 11, width: 18, color: mutedColor(40) }}>
                    {r.rank}
                  </span>
                  <span style={{ minWidth: 0, flex: 1 }}>
                    <span style={{ display: "block", fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {r.title}
                    </span>
                    <span style={{ display: "block", fontSize: 10.5, color: mutedColor(45) }}>{r.sub}</span>
                  </span>
                  <span style={{ fontFamily: "var(--font-heading)", fontSize: 12, color: "var(--color-accent)" }}>
                    {r.val}
                  </span>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
